export const checkIsTollFreePhoneNumber = (phoneNumber?: string): boolean => {
  if (!phoneNumber) return false;
  const tollFreeNumberRegex = /^(?:1)?(?:800|888|877|866|855|844|833)[0-9]{7}$/;
  const parsedPhoneNumber = phoneNumber.replace(/[^\d.-]+/g, '');
  return tollFreeNumberRegex.test(parsedPhoneNumber);
};
